import * as yup from 'yup';
import GenericField from '@/shared/fields/generic-field';
import { validators } from '@/shared/form/validators';
import { storeAsync } from '@/app-module';

export default class DecimalField extends GenericField {
    constructor(
        name,
        label,
        {
            required = false,
            min = undefined,
            max = undefined,
            scale = undefined,
        } = {},
        filterParams = {},
    ) {
        super(name, label, filterParams);

        this.type = 'decimal';
        this.required = required;
        this.min = min;
        this.max = max;
        this.scale = scale;
    }

    forPresenter(value) {
        if (!value) {
            return value;
        }

        if (this.scale === undefined || this.scale === null) {
            return value;
        }

        return Number(value).toFixed(this.scale);
    }

    forFormInitialValue(value) {
        if (value) {
            const separator = storeAsync().getters['shared/appConfig'].DECIMAL_SEPARATOR;
            return value.toFixed(2).replace(/\./g, separator);
        }

        return value;
    }

    forFilterInitialValue(value) {
        return value;
    }

    forFilterRules() {
        return undefined;
    }

    forFilterCast() {
        return yup
            .number()
            .nullable(true)
            .label(this.label);
    }

    forFormCast() {
        let yupChain = yup
            .number()
            .nullable(true)
            .label(this.label)
            .transform((_, value) => Number(parseFloat(value.replace(/,/g, '.')).toFixed(2)))

        return yupChain;
    }

    forFormRules() {
        let output = {
            ...validators.decimal(),
        };

        if (this.required) {
            output = {
                ...output,
                ...validators.required(),
            };
        }

        if (this.min || this.min === 0) {
            output = {
                ...output,
                ...validators.min(this.min),
            };
        }

        if (this.max || this.max === 0) {
            output = {
                ...output,
                ...validators.min(this.max),
            };
        }

        return output;
    }
}
